/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_3_AInputs */

const en_vc_faq_3_a = /** @type {(inputs: Vc_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The web version runs in any modern desktop browser through WebAssembly. Open VectorCraft online on this site, click Launch and start drawing. Your files stay on your own computer.`)
};

const zh_vc_faq_3_a = /** @type {(inputs: Vc_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。网页版通过 WebAssembly 在任何现代桌面浏览器中运行。打开本站的 VectorCraft 在线版，点击「启动」就能开始画图，文件始终保存在你自己的电脑上。`)
};

/**
* | output |
* | --- |
* | "Yes. The web version runs in any modern desktop browser through WebAssembly. Open VectorCraft online on this site, click Launch and start drawing. Your files..." |
*
* @param {Vc_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_3_a = /** @type {((inputs?: Vc_Faq_3_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_3_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_3_a(inputs)
	return zh_vc_faq_3_a(inputs)
});
export { vc_faq_3_a as "vc.faq.3.a" }